import { get, toString, isArray, includes } from 'lodash'

export function filters (items, filters) {

  return items.filter(d => {
    return Object.keys(filters).every(f => {
      try {
        if (filters[f].data.length > 1 && typeof filters[f].data == 'string' && filters[f].data.toString().match(/^[><=!]{1,2}/)) {
          let filter = filters[f].data
          if (filters[f].data.toString().match(/^[><=!]{1,2}/)[0] == '=') filter = '=' + filters[f].data
          return eval((get(d, f) || '0').toString() + filter)
        }
      } catch (e) {
        return true
      }

      if (!filters[f].data.length) {
        return true;
      }

      if (['autocomplete', 'select'].includes(filters[f].type)) {
        const value = `${get(d, f) || ''}`
          .split(',')
          .map(v => v.trim());

        return value.some(v => includes(filters[f].data, v));
      }

      return (
        (get(filters, [ f, 'valueType' ], 'string') == 'string' && toString((get(d, f) || '')).includes(filters[f].data) && toString((get(d, f) || '')).length > 0)
        || (get(filters, [ f, 'valueType' ], 'string') == 'number' && filters[f].data == (get(d, f) || 0) && toString((get(d, f) || 0)).length > 0)
        || (isArray(filters[f].data) && includes(filters[f].data, get(d, f)))
        || (filters[f].data.includes(true) && ((get(d, f) || '').toString().toLowerCase()).length > 0)
        || (filters[f].data.includes(false) && ((get(d, f) || '').toString().toLowerCase()).length == 0)
        || (typeof get(d, f) != 'boolean' && get(filters, [ f, 'valueType' ], 'string') == 'string' && ((get(d, f) || '').toString().toLowerCase()).indexOf(filters[f].data.toString().toLowerCase()) >= 0)
      )
    })
  })
}
